<div *ngIf="showChartTitle" class="card-heading table-Header-Nav-font" [ngClass]="customStyle === 'noMargin' ? 'noMarginClass' : 'chart-title'">{{title}}</div>
<div id="d" class="donut-chart">
  <div class="pie_div tcmcomponent-pie_div-height tcmcomponent-pie_div-padding pie_div-padding"></div>
  <div class="donut-state" *ngIf="loading" aria-live="polite" aria-busy="true">
    <div class="spinner"></div>
    <div class="loader-text">Loading chart...</div>
  </div>
  <div class="donut-state donut-error" *ngIf="!loading && errorMessage">
    {{ errorMessage }}
  </div>
  <div class="donut-state" *ngIf="!loading && !errorMessage && noDataFound">
    No data found.
  </div>
  <div class="donutcharttooltip"></div>
</div>
